export enum HomeworkTypeEnum {
    ASSIGNMENT = "Assignment",
    RESOURCE = "Resource",
}
